.ki{white-space:nowrap;}